import { DynamoDBClient, GetItemCommand, QueryCommand, ScanCommand } from '@aws-sdk/client-dynamodb';
import { setLoading, clearCaseStudy, fetchCaseStudiesSuccess, fetchCaseStudySuccess, fetchCaseStudiesFailure, fetchCaseStudyFailure, fetchCaseStudyIdAltRangeSuccess } from '../reducers/CaseStudySlice';
import { unmarshall } from '@aws-sdk/util-dynamodb';

// Flow: React App → API Gateway → Lambda → DynamoDB → Lambda → API Gateway → React App

// Function to get credentials from environment variables (Amplify will inject these)
const getClientWithCredentials = () => {
    const accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
    const secretAccessKey = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
    const region = process.env.REACT_APP_AWS_REGION;

    return new DynamoDBClient({
        region: region,
        credentials: {
            accessKeyId,
            secretAccessKey,
        },
    });
};

// Action to fetch case studies
// https://qddlzhmo64x5arxhbd6znogbfm0aegfn.lambda-url.us-east-2.on.aws/
export const fetchCaseStudies = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await fetch("https://qddlzhmo64x5arxhbd6znogbfm0aegfn.lambda-url.us-east-2.on.aws/");
    const data = await response.json();

    if (!response.ok) {
      throw new Error("Failed to fetch case studies");
    }

    const sorted = data
      .map((item) => ({
        ...item,
        case_study_id_alt: Number(item.case_study_id_alt),
      }))
      .sort((a, b) => b.case_study_id_alt - a.case_study_id_alt);

    dispatch(fetchCaseStudiesSuccess(sorted));
  } catch (error) {
    dispatch(fetchCaseStudiesFailure(error.message));
    dispatch(setLoading(false));
  }
};


// Action to fetch a specific case study by ID
// export const fetchCaseStudyById = (id) => async (dispatch) => {
//     try {
//         const client = getClientWithCredentials();
//         const params = {
//             TableName: 'Case_Studies',
//             Key: {
//                 case_study_id: { S: id },
//             },
//         };

//         const command = new GetItemCommand(params);
//         const response = await client.send(command);

//         if (response.Item) {
//             const caseStudy = unmarshall(response.Item);
//             if (caseStudy.case_study_description instanceof Set) {
//                 caseStudy.case_study_description = Array.from(caseStudy.case_study_description);
//             }
//             dispatch(fetchCaseStudySuccess(caseStudy));
//         } else {
//             console.log('No case study found with this ID.');
//         }
//     } catch (error) {
//         console.error("Error fetching case study:", error);
//     }
// };


// In CaseStudiesActions.js

export const fetchCaseStudyById = (id) => async (dispatch) => {
  dispatch(clearCaseStudy());
  dispatch(setLoading(true));
  try {
    const response = await fetch(
      `https://ksap4j6pkuuwz6gkz5ba7zkfbu0djwyr.lambda-url.us-east-2.on.aws?case_study_id=${encodeURIComponent(id)}`
    );


    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch case study");
    }

    dispatch(fetchCaseStudySuccess(data));
  } catch (error) {
    console.error("Error fetching case study:", error);
    dispatch(fetchCaseStudyFailure(error.toString()));
  }
};
  
// Action to fetch a specific case study by slug
export const fetchCaseStudyBySlug = (slug) => async (dispatch) => {
    try {
        const client = getClientWithCredentials();
        const params = {
            TableName: 'Case_Studies',
            IndexName: 'slug-index',
            KeyConditionExpression: 'case_study_slug = :slug',
            ExpressionAttributeValues: {
                ':slug': { S: slug },
            },
        };

        const command = new QueryCommand(params); // Use QueryCommand for GSI
        const response = await client.send(command);

        if (response.Items && response.Items.length > 0) {
            const caseStudy = unmarshall(response.Items[0]);
            dispatch(fetchCaseStudySuccess(caseStudy));
        } else {
            console.log('No case study found with this slug.');
        }
    } catch (error) {
        console.error('Error fetching case study by slug:', error);
    }
};

//https://ao7d4apaswhgwyemrs4rygpl7q0cugsg.lambda-url.us-east-2.on.aws/
export const fetchCaseStudyIdAltRange = () => async (dispatch) => {
  try {
    const response = await fetch(
      "https://ao7d4apaswhgwyemrs4rygpl7q0cugsg.lambda-url.us-east-2.on.aws?type=caseStudyIdAltRange"
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch case_study_id_alt range");
    }

    dispatch(fetchCaseStudyIdAltRangeSuccess(data));
  } catch (error) {
    console.error("Error fetching first and last case_study_id_alt:", error);
  }
};